/**
 * Builds the public/link URL a sharer hands out, carrying their referral
 * attribution (F72 §4/§27: "the shareable public/link URL carries the
 * sharer's referral attribution"; `ref` = the `shares.id`, resolved
 * server-side to `referral.sharerUserId`/`bookId` — never a separately
 * minted token, per `referralAttributionParam`'s doc comment in
 * `@xdocs/schemas`).
 */
export function buildDiscoverUrl(shareId: string): string {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origin}/discover/${shareId}?ref=${shareId}`;
}

/** Bearer capability URL for a `visibility='link'` share (F63). No referral
 * param — F72 attribution rides the PUBLIC url specifically per spec, and a
 * link share is deliberately never indexed/discoverable. */
export function buildLinkUrl(token: string): string {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origin}/s/${token}`;
}
